import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuth } from '../helpers/auth';

const PrivateRoute = ({ children }) => {
  const location = useLocation();

  return isAuth() ? (
    children
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default PrivateRoute;
